import React from "react";
import * as validator from "../../../general/validators/validator";
import { Avatar, CircularProgress, RaisedButton, TextField } from "material-ui";
import Header from "../../header";
import * as LoginService from "../../../services/loginService";
import { Constants } from "../../../constants";
import {
  ERROR_ALREADY_IN_APPROVAL_FLOW,
  PASSWORD_TOO_SHORT,
  WRONG_OLD_PASSWORD
} from "../../../general/response-codes";
import Select from "react-select";
import * as FlowService from "../../../services/flow-service";
import * as UserService from "../../../services/user-service";
import request from "../../../config/axios-config";
import * as axios from "axios";
import * as ErrorAction from "../../../redux/action/error-action";
import { connect } from "react-redux";
import { deepOrange300, purple500 } from "material-ui/styles/colors";

class SettingsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      oldPassword: "",
      newPasswordFirst: "",
      newPasswordSecond: "",
      savingPassword: false,
      savingPasswordSuccessful: false,
      savingPasswordFailed: false,
      loadingUser: true,
      fetchingUsersSuccessful: false,
      deletingDelegateFailed: false,
      deletingDelegateSuccessful: false,
      savingDelegateFailed: false,
      savingDelegateSuccessful: false,
      alreadyPartOfApproval: false,
      savingDelegate: false,
      error: {}
    };
  }

  componentDidMount() {
    axios
      .all([
        request({
          method: "get",
          url: "/flow/delegate"
        }),
        request({
          method: "get",
          url: "/user/all"
        })
      ])
      .then(
        axios.spread((delegatedUser, usersJson) => {
          let users = usersJson.data ? usersJson.data : [];
          let filteredUsers = users.filter(t => {
            return t.id !== this.props.userId;
          });
          let userOptions = filteredUsers.map((t, i) => {
            return { value: t.id, label: t.email };
          });

          let delegatedId = null;
          if (delegatedUser.data && delegatedUser.data.id) {
            delegatedId = delegatedUser.data.id;
          }
          this.setState({
            selectedUserId: delegatedId,
            userOptions: userOptions,
            fetchingUsersSuccessful: true,
            loadingUser: false
          });
        })
      )
      .catch(error => {
        this.setState({
          fetchingUsersSuccessful: false,
          loadingUser: false
        });
      });
  }

  onDelegateChanged = val => {
    this.setState({
      alreadyPartOfApproval: false,
      savingDelegateSuccessful: false,
      savingDelegateFailed: false,
      deletingDelegateSuccessful: false,
      deletingDelegateFailed: false,
      savingDelegate: true
    });
    if (val) {
      FlowService.saveDelegate(val)
        .then(json => {
          this.setState({
            savingDelegateSuccessful: true,
            selectedUserId: val,
            savingDelegate: false
          });
        })
        .catch(err => {
          let alreadyPartOfApproval = false;
          if (err.response.data.message === ERROR_ALREADY_IN_APPROVAL_FLOW) {
            alreadyPartOfApproval = true;
          }
          this.setState({
            savingDelegate: false,
            alreadyPartOfApproval: alreadyPartOfApproval,
            savingDelegateFailed: !alreadyPartOfApproval
          });
        });
    } else {
      FlowService.deleteDelegatedUser()
        .then(json => {
          this.setState({
            selectedUserId: null,
            deletingDelegateSuccessful: true,
            savingDelegate: false
          });
        })
        .catch(err => {
          this.setState({
            deletingDelegateFailed: true,
            savingDelegate: false
          });
        });
    }
  };

  onClickChangePassword = () => {
    if (!this.validateChangePassword()) {
      return;
    }
    this.setState({
      savingPassword: true
    });
    LoginService.changePassword(
      this.state.oldPassword,
      this.state.newPasswordFirst
    )
      .then(t => {
        this.setState({
          savingPasswordSuccessful: true,
          savingPassword: false,
          oldPassword: "",
          newPasswordFirst: "",
          newPasswordSecond: ""
        });
      })
      .catch(err => {
        let error = {};
        if (err.response.data.message === WRONG_OLD_PASSWORD) {
          error.summary = "Parola veche e gresita!";
        } else if (err.response.data.message === PASSWORD_TOO_SHORT) {
          error.summary = "Parola noua e prea scurta!";
        } else {
          error.summary = "A aparut o eroare. Va rog reincercati!";
        }
        this.setState({
          savingPasswordSuccessful: false,
          savingPassword: false,
          savingPasswordFailed: true,
          error: error
        });
      });
  };

  validateChangePassword = () => {
    let error = {};
    let isOk = true;
    /**/
    if (validator.isEmpty(this.state.oldPassword)) {
      error.oldPassword = "Lipseste parola veche";
      isOk = false;
    }
    if (validator.isEmpty(this.state.newPasswordFirst)) {
      error.newPasswordFirst = "Lipseste parola noua";
      isOk = false;
    }
    if (validator.isEmpty(this.state.newPasswordSecond)) {
      error.newPasswordSecond = "Lipseste parola noua";
      isOk = false;
    }
    if (
      !validator.isEmpty(this.state.newPasswordFirst) &&
      !validator.isEmpty(this.state.newPasswordSecond) &&
      this.state.newPasswordFirst !== this.state.newPasswordSecond
    ) {
      error.newPasswordSecond = "Ati gresit parola";
      isOk = false;
    }
    if (
      isOk &&
      this.state.newPasswordFirst.length < Constants.MIN_PASSWORD_LENGTH
    ) {
      error.newPasswordSecond = "Parola e prea scurta. Minim 6 caractere";
      isOk = false;
    }

    this.setState({
      error: error
    });

    return isOk;
  };

  render() {
    return (
      <div>
        <Header title={"Setari cont"} />

        <div style={{ textAlign: "center" }}>
          <div>
            <div>
              <h4>Schimbati parola:</h4>

              <TextField
                style={{ marginLeft: "20px" }}
                type={"password"}
                floatingLabelText={"Parola veche"}
                value={this.state.oldPassword}
                errorText={this.state.error.oldPassword}
                onChange={e => this.setState({ oldPassword: e.target.value })}
              />

              <TextField
                style={{ marginLeft: "10px" }}
                type={"password"}
                floatingLabelText={"Parola noua"}
                value={this.state.newPasswordFirst}
                errorText={this.state.error.newPasswordFirst}
                onChange={e =>
                  this.setState({ newPasswordFirst: e.target.value })
                }
              />

              <TextField
                style={{ marginLeft: "10px" }}
                type={"password"}
                floatingLabelText={"Repetati noua parola"}
                value={this.state.newPasswordSecond}
                errorText={this.state.error.newPasswordSecond}
                onChange={e =>
                  this.setState({ newPasswordSecond: e.target.value })
                }
              />
              <RaisedButton
                style={{ marginLeft: "20px" }}
                primary
                label={"Schimba"}
                onClick={() => this.onClickChangePassword()}
              />
            </div>

            <div>
              {this.state.savingPassword && (
                <CircularProgress style={{ marginTop: "10px" }} />
              )}

              {this.state.savingPasswordSuccessful && (
                <strong style={{ color: "#008000", marginTop: "10px" }}>
                  Parola a fost schimbata cu succes!
                </strong>
              )}

              {this.state.savingPasswordFailed &&
                this.state.error.summary && (
                  <strong style={{ color: "#FF0000", marginTop: "10px" }}>
                    {this.state.error.summary}
                  </strong>
                )}
            </div>
          </div>

          {this.props.isInApprovalFlow &&
            !this.props.isDelegated && (
              <div>
                <h4 style={{ marginTop: "50px" }}>
                  Delegati dreptul de aprobare catre:
                </h4>

                {this.state.loadingUser && (
                  <CircularProgress style={{ marginTop: "10px" }} />
                )}
                {this.state.fetchingUsersSuccessful && (
                  <div style={{ textAlign: "center" }}>
                    <div style={{ width: "35%", display: "inline-block" }}>
                      <Select
                        ref="stateSelect"
                        autoFocus
                        options={this.state.userOptions}
                        simpleValue
                        clearable={true}
                        name="selected-state"
                        disabled={false}
                        value={this.state.selectedUserId}
                        onChange={val => this.onDelegateChanged(val)}
                        searchable={true}
                      />
                      <div>
                        {this.state.error.selectedUser && (
                          <div
                            style={{
                              fontSize: "12px",
                              color: "rgb(244, 67, 54)",
                              marginTop: "5px"
                            }}
                          >
                            {this.state.error.selectedUser}
                          </div>
                        )}
                      </div>
                    </div>

                    {this.state.savingDelegate && (
                      <CircularProgress
                        style={{ marginTop: "10px", marginLeft: "20px" }}
                        size={30}
                      />
                    )}

                    <div>
                      {this.state.deletingDelegateSuccessful && (
                        <strong style={{ color: "#008000" }}>
                          Dreptul de aprobare al delegatului a fost sters cu
                          succes!
                        </strong>
                      )}

                      {this.state.deletingDelegateFailed && (
                        <strong style={{ color: "#FF0000" }}>
                          A aparut o eroare! Actiunea a esuat. Va rog
                          reincercati!
                        </strong>
                      )}

                      {this.state.alreadyPartOfApproval && (
                        <strong style={{ color: "#FF0000" }}>
                          Utilizatorul face parte deja din procesul de aprovare!
                          Alegeti alta persoana!
                        </strong>
                      )}

                      {this.state.savingDelegateSuccessful && (
                        <strong style={{ color: "#008000" }}>
                          Actiunea s-a finalizat cu succes!
                        </strong>
                      )}

                      {this.state.savingDelegateFailed && (
                        <strong style={{ color: "#FF0000" }}>
                          A aparut o eroare. Va rog reincercati!
                        </strong>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userId: state.login.user.id,
    isInApprovalFlow: state.login.user.isInApprovalFlow,
    isDelegated: state.login.user.isDelegated
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showError: text => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsPage);
